<script>
import rpcjs from 'rpcjs';
import {setContext} from 'svelte';
import Desktop from './desktop';
import Mobile from './mobile';
import {pageWidth, pageHeight, pageDimension} from './store';

const {title, createUrlStore} = rpcjs.props;
export let ssrUrl = '';
setContext('APP', {url: createUrlStore(ssrUrl)});

let height; let width;
$: $pageWidth = width;
$: $pageHeight = height;
let loadMobileVersion = false;

$: if ($pageWidth != undefined && $pageHeight != undefined) {
    $pageDimension = $pageHeight / $pageWidth;
    loadMobileVersion = true;
}

</script>

<svelte:head>
	<title> Opus | {$title}</title>
</svelte:head>

<svelte:window bind:innerHeight={height} bind:innerWidth={width}/>
<main>
	<div class="desktop">
		<Desktop />
	</div>
	{#if loadMobileVersion}
	<div class="mobile">
		<Mobile />
	</div>
	{/if}
</main>

<style>
	:global(body) {
		font-family: "Red Hat Text";
		margin: 0;
		padding: 0;
	}
	:global(a) {
		text-decoration: none;
		color: inherit;
	}
	.mobile {
        display: none;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }

    }
</style>
